// src/actions/hotel_actions.js

// ---------- Imports ----------
import { fetchHotels } from "../util/hotels_api_util"; // adjust path if needed

// ---------- Constants ----------
export const HOTELS_REQUEST = "HOTELS_REQUEST";
export const HOTELS_SUCCESS = "HOTELS_SUCCESS";
export const HOTELS_FAILURE = "HOTELS_FAILURE";
export const HOTELS_SET_SELECTION = "HOTELS_SET_SELECTION";
export const HOTELS_SET_VIEW_MODE = "HOTELS_SET_VIEW_MODE"; // <-- NEW

// ---------- Action Creators ----------
export const hotelsRequest = () => ({ type: HOTELS_REQUEST });

export const hotelsSuccess = (hotels) => ({
  type: HOTELS_SUCCESS,
  payload: hotels,
});

export const hotelsFailure = (error) => ({
  type: HOTELS_FAILURE,
  error,
});

/** Merge a partial selection (e.g., { continent: "Asia" }). */
export const setHotelsSelection = (partial) => ({
  type: HOTELS_SET_SELECTION,
  payload: partial,
});

/** Grid/List (or any string you choose, e.g., "grid" | "list"). */
export const setHotelsViewMode = (mode) => ({
  type: HOTELS_SET_VIEW_MODE,
  payload: mode,
});

// ---------- Thunks ----------
export const fetchAllHotels = () => async (dispatch) => {
  dispatch(hotelsRequest());
  try {
    const hotels = await fetchHotels();
    dispatch(hotelsSuccess(hotels));
  } catch (err) {
    dispatch(hotelsFailure(err?.message || String(err)));
  }
};
